'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import analytics from '../../helpers/analytics'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _ComcastPetitionThanks = require('./ComcastPetitionThanks.css');

var _ComcastPetitionThanks2 = _interopRequireDefault(_ComcastPetitionThanks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComcastPetitionThanks = (_dec = (0, _reactCssModules2.default)(_ComcastPetitionThanks2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(ComcastPetitionThanks, _Component);

  function ComcastPetitionThanks(props) {
    (0, _classCallCheck3.default)(this, ComcastPetitionThanks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ComcastPetitionThanks.__proto__ || (0, _getPrototypeOf2.default)(ComcastPetitionThanks)).call(this, props));

    _this.state = {
      tweets: [{
        jsx: _react2.default.createElement(
          'span',
          null,
          'I just signed a petition from @AsYouSow: @Comcast, Stop Investing Employee Savings into Prisons! Join me by signing here #RacialJustice #InvestYourValues ',
          _react2.default.createElement(
            'span',
            { style: { textDecoration: 'underline' } },
            'investyourvalues.org/comcast'
          )
        ),
        plainText: 'I just signed a petition from @AsYouSow: @Comcast, Stop Investing Employee Savings into Prisons! Join me by signing here #RacialJustice #InvestYourValues'
      }, {
        jsx: _react2.default.createElement(
          'span',
          null,
          'It\u2019s time @Comcast stops investing employee savings into private prisons! Join me and @AsYouSow by signing this petition #RacialJustice #InvestYourValues ',
          _react2.default.createElement(
            'span',
            { style: { textDecoration: 'underline' } },
            'investyourvalues.org/comcast'
          )
        ),
        plainText: 'It’s time @Comcast stops investing employee savings into private prisons! Join me and @AsYouSow by signing this petition #RacialJustice #InvestYourValues'
      }, {
        jsx: _react2.default.createElement(
          'span',
          null,
          'Urge @Comcast management to live up to their public commitments by offering a prison-free default retirement fund! Join me in signing @AsYouSow\u2019s petition #RacialJustice #InvestYourValues ',
          _react2.default.createElement(
            'span',
            { style: { textDecoration: 'underline' } },
            'investyourvalues.org/comcast'
          )
        ),
        plainText: 'Urge @Comcast management to live up to their public commitments by offering a prison-free default retirement fund! Join me in signing @AsYouSow’s petition #RacialJustice #InvestYourValues'
      }]
    };
    return _this;
  }

  (0, _createClass3.default)(ComcastPetitionThanks, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var tweets = this.state.tweets;

      var pageTitle = 'Thanks for your support';
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'gray-bckgrnd' },
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _container2.default.helmet(pageTitle, 'Thanks for supporting our petition asking Comcast to stop investing employee savings into prisons', _config2.default.domain + _config2.default.routes.comcastPetitionThanks),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'large-page-title' },
              'Thank you for your support!'
            ),
            _react2.default.createElement(_components.PetitionRotatingTweet, {
              companyName: 'Comcast',
              tweets: tweets,
              url: _config2.default.domain + _config2.default.routes.comcastPetitionLanding
            }),
            _react2.default.createElement(_components.PlanScorecardTakeActionShare, {
              url: _config2.default.domain + _config2.default.routes.comcastPetitionLanding,
              description: 'Check out this petition from As You Sow asking Comcast to stop investing employee savings into prisons',
              petition: true
            })
          ),
          _react2.default.createElement(_components.PlanScorecardToActionCenter, null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return ComcastPetitionThanks;
}(_react.Component)) || _class);
exports.default = ComcastPetitionThanks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ComcastPetitionThanks/ComcastPetitionThanks.js
// module id = 1467
// module chunks = 0